import { grayBg } from '@/constant'
import { styled, Box, Button } from '@mui/material'
import Apps from './Apps'
import {
  getOrgsApplications,
  getPurchasedApplications,
  setDefaultOrg,
  subscribeApplication,
  getUerPermissions,
  getOrgInfo,
} from '@/api'

const Main = styled('div')(() => ({
  marginTop: '64px',
  paddingTop: '30px',
  // background: `url(${workbenchBg}) no-repeat`,
}))

const Layout = styled('div')(() => ({
  backgroundColor: grayBg,
  height: '100vh',
  overflowY: 'auto',
  pb: 5,
  paddingBottom: 40,
}))

const AdBox = styled('div')(() => ({
  position: 'relative',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1200px',
  margin: '0 auto 24px',
  height: 48,
  background: 'linear-gradient( 90deg, #206CFF 0%, #9A6DEF 100%)',
  borderRadius: '8px',
  padding: '0 60px',
  fontSize: 20,
  fontWeight: 700,
}))

const Workbench = () => {
  return (
    <Layout id='workbench-layout'>
      <Main>
        {/* {showAd && (
          <AdBox onClick={() => navigate('/console/personal/promotion')}>
            <Box sx={{ color: '#fff' }}>加入百川云</Box>
            <Box
              sx={{
                ml: 2,
                mr: 4,
                background: 'linear-gradient(0deg, #FF8F36 0%, #F6CA51 100%)',
                backgroundClip: 'text',
                color: 'transparent',
              }}
            >
              推广大使
            </Box>
            <Box sx={{ fontSize: 16, color: '#fff', mr: '72px' }}>多分享多分成·真的能提现！</Box>
            <Button
              variant='outlined'
              sx={{ fontWeight: 700, height: 28, background: '#fff !important', borderColor: '#fff !important' }}
            >
              立即加入
            </Button>
            <CloseRoundedIcon
              sx={{
                color: '#cdcdcd',
                fontSize: 20,
                position: 'absolute',
                right: 24,
                cursor: 'pointer',
                '&:hover': {
                  color: '#fff',
                },
              }}
              onClick={(e) => {
                e.stopPropagation()
                setShowAd(false)
              }}
            />
          </AdBox>
        )} */}

        <Apps />
      </Main>
    </Layout>
  )
}

export default Workbench
